import React from 'react';
import { FadeIn } from './Shared';
import { CheckCircle2, XCircle } from 'lucide-react';
export function TargetAudience() {
  const isFor = ["High-functioning Aussies who 'ghost' vape in bathrooms or cars.", 'People spending $40-$60 a week on IGETs, HQDs, or Gunnpods.', "Anyone who feels a 'heavy chest' or morning cough but can't seem to stop.", 'Those who are tired of being controlled by a $30 piece of plastic.'];
  const notFor = ["People looking for a 'magic pill' that requires zero effort.", 'Non-smokers looking to start vaping.', "Anyone who isn't ready to follow a structured 21-day plan."];
  return <section className="py-24 px-4 bg-[#0a0a0a] relative border-t border-neutral-900" data-id="element-169">
      <div className="max-w-5xl mx-auto" data-id="element-170">
        <div className="grid md:grid-cols-2 gap-8" data-id="element-171">
          <FadeIn data-id="element-172">
            <div className="bg-neutral-900/40 border border-toxic/20 p-8 md:p-10" data-id="element-173">
              <h3 className="text-2xl font-black uppercase mb-8 flex items-center gap-3" data-id="element-174">
                <CheckCircle2 className="text-toxic" size={28} data-id="element-175" />
                Who This Is For
              </h3>
              <ul className="space-y-6" data-id="element-176">
                {isFor.map((item, i) => <li key={i} className="flex gap-4 text-neutral-300" data-id="element-177">
                    <div className="w-1.5 h-1.5 bg-toxic rounded-full mt-2.5 shrink-0" data-id="element-178" />
                    <span className="leading-relaxed" data-id="element-179">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-180">
            <div className="bg-neutral-900/40 border border-red-500/20 p-8 md:p-10" data-id="element-181">
              <h3 className="text-2xl font-black uppercase mb-8 flex items-center gap-3" data-id="element-182">
                <XCircle className="text-red-500" size={28} data-id="element-183" />
                Who This Is NOT For
              </h3>
              <ul className="space-y-6" data-id="element-184">
                {notFor.map((item, i) => <li key={i} className="flex gap-4 text-neutral-400" data-id="element-185">
                    <div className="w-1.5 h-1.5 bg-red-500 rounded-full mt-2.5 shrink-0" data-id="element-186" />
                    <span className="leading-relaxed" data-id="element-187">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}